import React, { Component } from 'react';
import { LoadingOverlay } from '@deephaven/components';
import Log from '@deephaven/log';
import PanelEvent from "./PanelEvent.js";
import LayoutUtils from "./layout/LayoutUtils.js";
import "./PanelErrorBoundary.css";
import { jsx as _jsx } from "react/jsx-runtime";
var log = Log.module('PanelErrorBoundary');
/**
 * Panel wrapper implementing Error Boundary and emitting Closed event.
 * Closed event has to be emitted from the wrapper instead of the panel itself
 * because the panel can get unmounted on errors
 * and we want to differentiate between unmount on error vs panel being intentionally closed.
 */
class PanelErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null
    };
  }
  componentDidCatch(error) {
    this.setState({
      error
    });
  }
  componentWillUnmount() {
    var _this$props = this.props,
      glContainer = _this$props.glContainer,
      glEventHub = _this$props.glEventHub;
    var panelId = LayoutUtils.getIdFromContainer(glContainer);
    log.debug('componentWillUnmount', panelId);
    glEventHub.emit(PanelEvent.CLOSED, panelId, glContainer);
  }
  render() {
    var children = this.props.children;
    var error = this.state.error;
    if (error != null) {
      return /*#__PURE__*/_jsx("div", {
        className: "panel-error-boundary",
        children: /*#__PURE__*/_jsx(LoadingOverlay, {
          "data-testid": "panel-error-boundary-loading-error",
          errorMessage: "".concat(error),
          isLoading: false,
          isLoaded: false
        })
      });
    }

    // We need to check for undefined children because React will throw an error if we return undefined from a render method
    // Note this behaviour was changed in React 18: https://github.com/reactwg/react-18/discussions/75
    return children !== null && children !== void 0 ? children : null;
  }
}
export default PanelErrorBoundary;
//# sourceMappingURL=PanelErrorBoundary.js.map